import { getIntlLocaleFromLocale } from '@repo/utils'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useLocale } from '../../../../../hooks/use-locale'
import { IntlLocales } from '../../../../../lib/graphql'
import { Icon } from '../../../../atoms'

export interface IHouseTranslatedContentProps extends HouseTranslationParams {
  originalLocale: IntlLocales
}

export interface HouseTranslationParams {
  displayedLocale: IntlLocales | undefined
  onDisplayedLocaleChange: (locale: IntlLocales) => void
}

export const HouseTranslatedContent = ({
  originalLocale,
  displayedLocale,
  onDisplayedLocaleChange,
}: IHouseTranslatedContentProps) => {
  const { locale } = useLocale()

  if (getIntlLocaleFromLocale(locale) === originalLocale) {
    return null
  }

  const isTranslatedContent = originalLocale !== displayedLocale

  return (
    <div className='mb-4 flex items-center rounded-lg bg-accent p-4'>
      <Icon name='translate' size={40} className='flex' />

      <div className='ml-2 flex flex-1 flex-col'>
        <p>
          {isTranslatedContent ? (
            <FormattedMessage
              id='ui.HouseTranslatedContent.translatedContent'
              defaultMessage='Certaines informations ont été traduites automatiquement.'
            />
          ) : (
            <FormattedMessage
              id='ui.HouseTranslatedContent.originalContent'
              defaultMessage='Certaines informations s’affichent dans la langue d’origine.'
            />
          )}
        </p>
        <button
          className='-mx-1 cursor-pointer self-start rounded px-1 underline focus-visible:ring-2'
          onClick={() =>
            onDisplayedLocaleChange(
              isTranslatedContent
                ? originalLocale
                : getIntlLocaleFromLocale(locale),
            )
          }
        >
          {isTranslatedContent ? (
            <FormattedMessage
              id='ui.HouseTranslatedContent.showOriginalContent'
              defaultMessage='Afficher le texte d’origine'
            />
          ) : (
            <FormattedMessage
              id='ui.HouseTranslatedContent.showTranslatedContent'
              defaultMessage='Traduire'
            />
          )}
        </button>
      </div>
    </div>
  )
}
